export enum CopperAmounts {
    CopperInSilver = 10,
    CopperInGold = 100,
    CopperInPlatinum = 1000,
    CopperIn100Platinum = 100000,
}

export enum CurrencyIndices {
    Platinum = 0,
    Gold = 1,
    Silver = 2,
    Copper = 3,
}
